import React from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { labelMap } from '../constants';
import { useLocationPicker } from '../store';
import { LocationPickerSearchFilters } from '../types';

type LocationSearchGroupProps = {
  children: React.ReactNode;
  id: LocationPickerSearchFilters;
};

export const LocationSearchGroup = ({ children, id }: LocationSearchGroupProps) => {
  const { activeSearchFilter } = useLocationPicker(['activeSearchFilter']);

  if (activeSearchFilter !== id) return null;

  return (
    <div
      css={css`
        padding: ${theme.spacing(0, 2)};
        padding-top: ${theme.spacing(2)};
      `}
    >
      <header
        css={css`
          display: flex;
          align-items: center;
          gap: ${theme.spacing(1)};
        `}
      >
        <Text as='h4' size='medium' weight='bold'>
          {labelMap[id]}
        </Text>
      </header>
      {children}
    </div>
  );
};
